/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import CurrencyInput from 'react-currency-input-field';
import { useDispatch, useSelector } from 'react-redux';
import companyId from 'services/company_id';
import { ApplicationState } from 'store';
import { finishManaged } from 'store/modules/management_store/actions';
import { ManagementState } from 'store/modules/management_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';

interface ManagementFinishBiddingProps {
  modalFinishBiddingOpened: boolean;
  setModalFinishBiddingOpened: React.Dispatch<React.SetStateAction<boolean>>;
  biddingId: number;
  totalOpenedTaks: number;
}

const ManagementFinishBidding = (props: ManagementFinishBiddingProps) => {
  const { modalFinishBiddingOpened, setModalFinishBiddingOpened, biddingId, totalOpenedTaks } =
    props;
  const dispatch = useDispatch();
  const [finishedStatusSelected, setFinishedStatusSelected] = useState<string>('');
  const [amount, setAmount] = useState<string | undefined>('');
  const [comments, setComments] = useState<string>('');
  const [showError, setShowError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [saveClicked, setSaveClicked] = useState<boolean>(false);

  const { request } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const SHORT_DELAY = 2000;

  useEffect(() => {
    if (!saveClicked) return;
    if (request.finish_managed.loading) return;

    setShowSuccess(true);
  }, [request.finish_managed.loaded]);

  useEffect(() => {
    if (!showSuccess) return;

    setTimeout(() => {
      setShowSuccess(false);
      setModalFinishBiddingOpened(false);
    }, SHORT_DELAY);
  }, [showSuccess]);

  useEffect(() => {
    if (!saveClicked) return;
    if (request.finish_managed.loading) return;

    setShowError(true);
  }, [request.finish_managed.error]);

  useEffect(() => {
    if (!showError) return;

    setTimeout(() => {
      setShowError(false);
    }, SHORT_DELAY);
  }, [showError]);

  return (
    <Modal show={modalFinishBiddingOpened} size="sm">
      <div className="modal-content">
        <div className="modal-header">
          <h6 className="modal-title" id="modalLabel">
            Finalizar licitação
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setModalFinishBiddingOpened(!modalFinishBiddingOpened);
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          {showError && (
            <div className="my-2 alert alert-danger text-center">
              <button
                type="button"
                id="close-alert"
                className="close"
                onClick={() => setShowError(false)}
              >
                ×
              </button>
              Erro ao finalizar licitação.
            </div>
          )}
          {showSuccess && (
            <div className="my-2 alert alert-success text-center p-2 d-flex align-items-center">
              Licitação finalizada com sucesso!
              <button
                type="button"
                id="close-alert"
                className="ml-2 close"
                onClick={() => setShowSuccess(false)}
              >
                ×
              </button>
            </div>
          )}
          <div className="mb-3">
            <div className="custom-control custom-radio">
              <input
                className="custom-control-input"
                type="radio"
                name="finish_management_status_id"
                id="radio-1"
                onChange={() => setFinishedStatusSelected('winner')}
              />
              <label className="custom-control-label" htmlFor="radio-1">
                Vencedor em todos os itens
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                className="custom-control-input"
                type="radio"
                name="finish_management_status_id"
                id="radio-2"
                onChange={() => setFinishedStatusSelected('partial_winner')}
              />
              <label className="custom-control-label" htmlFor="radio-2">
                Vencedor em alguns itens
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                className="custom-control-input"
                type="radio"
                name="finish_management_status_id"
                id="radio-3"
                onChange={() => setFinishedStatusSelected('lost')}
              />
              <label className="custom-control-label" htmlFor="radio-3">
                Nenhum item ganho
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                className="custom-control-input"
                type="radio"
                name="finish_management_status_id"
                id="radio-4"
                onChange={() => setFinishedStatusSelected('cancelled')}
              />
              <label className="custom-control-label" htmlFor="radio-4">
                A licitação foi anulada
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                className="custom-control-input"
                type="radio"
                name="finish_management_status_id"
                id="radio-5"
                onChange={() => setFinishedStatusSelected('failed')}
              />
              <label className="custom-control-label" htmlFor="radio-5">
                A licitação foi fracassada
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                className="custom-control-input"
                type="radio"
                name="finish_management_status_id"
                id="radio-6"
                onChange={() => setFinishedStatusSelected('revoked')}
              />
              <label className="custom-control-label" htmlFor="radio-6">
                A licitação foi revogada
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                className="custom-control-input"
                type="radio"
                name="finish_management_status_id"
                id="radio-7"
                onChange={() => setFinishedStatusSelected('declined')}
              />
              <label className="custom-control-label" htmlFor="radio-7">
                Declinamos da participação
              </label>
            </div>
          </div>
          {(finishedStatusSelected === 'winner' || finishedStatusSelected === 'partial_winner') && (
            <div className="mb-3">
              <label className="font-weight-bold" id="value-won">
                Valor total ganho nesta licitação
              </label>
              <div className="input-group input-group-sm">
                <CurrencyInput
                  className="form-control"
                  id="value-won"
                  name="value-won"
                  placeholder="Valor total ganho nesta licitação"
                  prefix="R$ "
                  defaultValue={0}
                  decimalsLimit={2}
                  onValueChange={(value) => setAmount(value)}
                />
              </div>
            </div>
          )}

          <div className="mb-3">
            <label htmlFor="comments" className="font-weight-bold">
              Observações
            </label>
            <textarea
              id="comments"
              name="comments"
              className="form-control"
              onChange={(event) => setComments(event.target.value)}
            />
          </div>
          {totalOpenedTaks > 0 && (
            <div className="alert alert-warning" role="alert">
              Ao remover a licitação todas as tarefas em aberto serão finalizadas. Deseja continuar?
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-md btn-block btn-primary"
            disabled={request.finish_managed.loading || showSuccess}
            onClick={() => {
              if (request.finish_managed.loading || showSuccess) return;
              dispatch(
                finishManaged(
                  biddingId,
                  finishedStatusSelected,
                  comments,
                  companyId(profile),
                  amount,
                ),
              );
              setSaveClicked(true);
              createTrack('Gestão de Licitações - Finalizou uma licitação do Gerenciamento');
              track('gestao.finalizou_licitacao_gerenciada', { bidding_id: biddingId });
            }}
          >
            Finalizar
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ManagementFinishBidding;
